export enum InputActionsType {
    Checked = "checked",
    Unchecked = "unchecked"
}
